export default "__VITE_ASSET__c70ba1cb__"